import { LinkedAppJSONHTTPBinding } from "../types/restapi";
import { GetCustomerHistoryRequest, GetCustomerHistoryResponse, AuthContext, CustomerContactStatusRequest, CustomerContactStatusResponse, CustomerContactEmailChangeRequest, CustomerContactEmailChangeResponse, ContactType, SendContactConfirmationRequest, SendContactConfirmationResponse, SendContactConfirmationActionType, SaveContactConfirmationRequest, SaveContactConfirmationResponse, LandingpageResponse, LandingpageRequest, LandingpageRequestType, Tenant, LandingpageEmailWithTokenRequest } from "../types/apimodel";
import { generateCorrelationId } from "../util/util";
import {loadSessionData,KEY_AUTH_CONTEXT} from '../util/store';

const baseURL : string = String(process.env.REACT_APP_LINKEDAPP_BACKEND_ROOT);




const LinkedappBackend = {
 
    // getCustomerHistory: function(filterCriteria:ReportingFilterCriteria, countQuery: boolean, currentPage:number | null, pageSize:number| null, orderBy:string| null, sortOrder:string| null): Promise<GetCustomerHistoryResponse> {
    
    //getCustomerHistory: function(): Promise<GetCustomerHistoryResponse> {
        getCustomerHistory: function(orderBy:string| null, sortOrder:string| null): Promise<GetCustomerHistoryResponse> {
    
        const backend = new LinkedAppJSONHTTPBinding(baseURL);


        let authContext :AuthContext = loadSessionData(KEY_AUTH_CONTEXT);
       

        let request : GetCustomerHistoryRequest = {
            correlationId: generateCorrelationId(),
            linkId:loadSessionData('linkid'),
            authContext : authContext
            // filterCriteria: filterCriteria,
        };
        //if (currentPage !== null) {
        //     request.currentPage = currentPage;
        //}
        // if (pageSize !== null) {
        //     request.pageSize = pageSize;
        // }
        if (orderBy !== null) {
             request.orderBy = orderBy;
        }
        if (sortOrder !== null) {
             request.sortOrder = sortOrder;
        }
        
        return backend.getCustomerHistory(request);
    },

    unsubscribe: function(pnr: string, firstName: string, lastName: string, eMail:string, vermittler: string, reason:string, tenant?: string) {
        return new LinkedAppJSONHTTPBinding(baseURL).unsubscribe({
            pnr: pnr,
            firstName: firstName,
            lastName: lastName,
            recipient: eMail,
            broker: vermittler,
            correlationId: generateCorrelationId(),
            reason: reason,
            tenant: tenant??"RHEINLAND"
        });
    },
   
    getLinkedAppLinkUrl : function(parameter :string){
        let cid = loadSessionData("cid");
        LinkedappBackend.getRedirectUrl(parameter, cid, "linkedapp").then(result => {
            if(result !== undefined) {
                result = result + "&cid="+cid;
                console.log("open link " + result);
                window.open(result, "_self");
            }
            else {
              console.log("Error on getting linkedappurl. Calling /neuladen");
              return "/neuladen";
            }
        });
    },

    getRedirectUrl : (relativeUrl: string,
                      cid: "rd" | "rl" | "cl",
                      app: "linkedapp" | "linkedapp-kundenakte") : Promise<string> => {
        return new LinkedAppJSONHTTPBinding(baseURL)?.getLinkedAppRedirectUrl({
            relativeUrl, cid, app
        });
    },

    getLinkedAppLinkUnsubscribe : (partnerNo: string, firstName: string, lastName: string, eMail:string, broker: string) : Promise<any> => {
        return new LinkedAppJSONHTTPBinding(baseURL)?.getLinkedAppLinkUnsubscribe({
            partnerNo: partnerNo,
            eMail: eMail,
            firstName: firstName,
            lastName: lastName,
            brokerId: broker
        });
    },

    logout: function():string {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        return backend.logout();
    },

    getCustomerContactStatus: function(linkId:string, authContext:AuthContext): Promise<CustomerContactStatusResponse> {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        let request : CustomerContactStatusRequest = {
            linkId : linkId,
            authContext: authContext,
            correlationId: generateCorrelationId()
        };
        return backend.getCustomerContactStatus(request);
    },

    sendContactConfirmation(linkId:string, authContext:AuthContext, contactType:ContactType, contact:string): Promise<SendContactConfirmationResponse> {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        let request : SendContactConfirmationRequest = {
            linkId : linkId,
            authContext: authContext,
            correlationId: generateCorrelationId(),
            contactType: contactType,
            contact: contact,
            sendContactConfirmationAction:  SendContactConfirmationActionType.CONTACT_CONFIRMATION_CHANGE_MOBILE,
        };
        return backend.sendContactConfirmation(request);
    },
    
    setCustomercontactemailchange: function(linkId:string, authContext:AuthContext, email: string): Promise<CustomerContactEmailChangeResponse> {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        let request : CustomerContactEmailChangeRequest = {
            linkId : linkId,
            authContext: authContext,
            correlationId: generateCorrelationId(),
            email :email,
        };
        return backend.setCustomercontactemailchange(request);
    },

    saveContactConfirmation: function(linkId:string, token: string): Promise<SaveContactConfirmationResponse> {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        let request : SaveContactConfirmationRequest = {
            linkId: linkId,
            token: token,
            correlationId: generateCorrelationId(),
        };
        return backend.saveContactConfirmation(request);
    },

    getLandingpageLink: function(vorname:string,nachname:string,plz:string,vsnr:string, landingpageRequestType:LandingpageRequestType,tenant:Tenant, emailchoosen:string): Promise<LandingpageResponse> {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        let request : LandingpageRequest = {
            vorname: vorname,
            nachname: nachname,
            plz: plz,
            vsnr: vsnr,
            correlationId: generateCorrelationId(),
            landingpageRequestType: landingpageRequestType,
            tenant:tenant,
            email:emailchoosen
        };
        return backend.getLandingpageLink(request);
    },

    getLandingpageLinkForEmail: function(lpfromlinktoken:string, landingpageRequestType:LandingpageRequestType, emailchoosen:string): Promise<LandingpageResponse> {
        let backend = new LinkedAppJSONHTTPBinding(baseURL);
        let request : LandingpageEmailWithTokenRequest = {
            lpfromlinktoken: lpfromlinktoken,
            correlationId: generateCorrelationId(),
            landingpageRequestType: landingpageRequestType,
            email:emailchoosen
        };
        return backend.getLandingpageLinkForEmailWithToken(request);
    },

};

export default LinkedappBackend;
